import { ResolvableModeEnum } from '@e-socna/data-layer';

import { NoPrimaryWrapper } from '../../../ResolvableFields/NoPrimaryWrapper';
import type { ResolvableFieldSettings } from '../../../ResolvableFields/types/resolvable-field-settings.type';

import { SecondaryWrapper } from '../SecondaryWrapper';

export const buildDisplayParameters = (
  resolvableFieldSettings: Readonly<Partial<ResolvableFieldSettings>>,
) => ({
  PrimaryWrapper: NoPrimaryWrapper,
  resolvableFieldSettings: {
    enableDirectGeneration:
      resolvableFieldSettings.enableDirectGeneration ?? true,
    primaryMode:
      resolvableFieldSettings.primaryMode ?? ResolvableModeEnum.Static,
  },
  SecondaryWrapper,
});
